export const initSearch = () => {
  const navSearch = document.querySelector(
    '.custom-page-header .custom-main-header .search-icon .et_pb_searchform .et_pb_s',
  );

  navSearch.setAttribute('aria-label', 'Search');
};
